module.exports = __webpack_public_path__ + "static/Jira_Hero-d87fcc4f2c5fb53d656db3e58d0d55b1.png";